module.exports = __webpack_public_path__ + "assets/img/contact.f7bf92b5.svg";